/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldpricehint3Inputs */

const en_ticketsfieldpricehint3 = /** @type {(inputs: Ticketsfieldpricehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 or empty means free.`)
};

const de_ticketsfieldpricehint3 = /** @type {(inputs: Ticketsfieldpricehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 oder leer heißt kostenlos.`)
};

/**
* | output |
* | --- |
* | "0 or empty means free." |
*
* @param {Ticketsfieldpricehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldpricehint3 = /** @type {((inputs?: Ticketsfieldpricehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldpricehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldpricehint3(inputs)
	return de_ticketsfieldpricehint3(inputs)
});
export { ticketsfieldpricehint3 as "ticketsFieldPriceHint" }